import { render } from "./AquaparkNews.vue?vue&type=template&id=07b0a6bd"
import script from "./AquaparkNews.vue?vue&type=script&lang=js"
export * from "./AquaparkNews.vue?vue&type=script&lang=js"

import "./AquaparkNews.vue?vue&type=style&index=0&id=07b0a6bd&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__